import { IUserHttpParams } from '@core/interfaces/api.interface';
import {
	RouteBaseDefinition,
	RouteBasePath
}                          from '@core/interfaces/route.interface';


export enum UserRoutesEnum {
	ListPage = '',
	DetailPage = ':userId',
	FormPageCreate = 'create',
	FormPageUpdate = ':userId/update',
	FormPageChangePassword = ':userId/change-password',
}

export interface UserListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Users;

	path: UserRoutesEnum.ListPage;

	queryParams?: IUserHttpParams;
}

export interface UserDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Users;

	path: UserRoutesEnum.DetailPage;

	params: { userId: string };
}

export interface UserFormPageCreateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Users;

	path: UserRoutesEnum.FormPageCreate;
}

export interface UserFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Users;

	path: UserRoutesEnum.FormPageUpdate;

	params: { userId: string };
}

export interface UserFormPageChangePasswordRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Users;

	path: UserRoutesEnum.FormPageChangePassword;

	params: { userId: string };
}
